/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetVitalsCustomersCustomerIdReadingsParams,
  TrainWithMeModulesVitalsDtosResponsesVitalCatalogResponse,
  TrainWithMeModulesVitalsDtosResponsesVitalReadingsResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getVitalsCatalog = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesVitalsDtosResponsesVitalCatalogResponse>(
      {url: `/vitals/catalog`, method: 'GET', signal
    },
      options);
    }




export const getGetVitalsCatalogQueryKey = () => {
    return [
    `/vitals/catalog`
    ] as const;
    }


export const getGetVitalsCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getVitalsCatalog>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVitalsCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVitalsCatalog>>> = ({ signal }) => getVitalsCatalog(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVitalsCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVitalsCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getVitalsCatalog>>>
export type GetVitalsCatalogQueryError = ErrorType<unknown>


export function useGetVitalsCatalog<TData = Awaited<ReturnType<typeof getVitalsCatalog>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVitalsCatalog>>,
          TError,
          Awaited<ReturnType<typeof getVitalsCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVitalsCatalog<TData = Awaited<ReturnType<typeof getVitalsCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVitalsCatalog>>,
          TError,
          Awaited<ReturnType<typeof getVitalsCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVitalsCatalog<TData = Awaited<ReturnType<typeof getVitalsCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVitalsCatalog<TData = Awaited<ReturnType<typeof getVitalsCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCatalog>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVitalsCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getVitalsCustomersCustomerIdReadings = (
    customerId: number,
    params?: GetVitalsCustomersCustomerIdReadingsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesVitalsDtosResponsesVitalReadingsResponse>(
      {url: `/vitals/customers/${customerId}/readings`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetVitalsCustomersCustomerIdReadingsQueryKey = (customerId: number,
    params?: GetVitalsCustomersCustomerIdReadingsParams,) => {
    return [
    `/vitals/customers/${customerId}/readings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVitalsCustomersCustomerIdReadingsQueryOptions = <TData = Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError = ErrorType<unknown>>(customerId: number,
    params?: GetVitalsCustomersCustomerIdReadingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVitalsCustomersCustomerIdReadingsQueryKey(customerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>> = ({ signal }) => getVitalsCustomersCustomerIdReadings(customerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVitalsCustomersCustomerIdReadingsQueryResult = NonNullable<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>>
export type GetVitalsCustomersCustomerIdReadingsQueryError = ErrorType<unknown>


export function useGetVitalsCustomersCustomerIdReadings<TData = Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError = ErrorType<unknown>>(
 customerId: number,
    params: undefined |  GetVitalsCustomersCustomerIdReadingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>,
          TError,
          Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVitalsCustomersCustomerIdReadings<TData = Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetVitalsCustomersCustomerIdReadingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>,
          TError,
          Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVitalsCustomersCustomerIdReadings<TData = Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetVitalsCustomersCustomerIdReadingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVitalsCustomersCustomerIdReadings<TData = Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError = ErrorType<unknown>>(
 customerId: number,
    params?: GetVitalsCustomersCustomerIdReadingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVitalsCustomersCustomerIdReadings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVitalsCustomersCustomerIdReadingsQueryOptions(customerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






